import http from './http';
export default {
    postShareCaptcha: function (param = {}) {
        return http.post('/v2.5/h5/shareCaptcha', { ...param })
    },
    postShareSubmit: function (param = {}) {
        return http.post('/v2.5/h5/shareSubmit', { ...param })
    }
}
